import React, {useCallback, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {connectedIcon, disconnectedIcon, disabledIcon} from '../../assets/images/gateway';
import {Link} from 'react-router-dom';
import plansIcon from '../../assets/images/plans.png';
import RowLayout from '../../components/Layouts/RowLayout';
import SMCButton from '../../components/Simple/SMCButton';
import ReactHtmlParser from 'react-html-parser';
import {useSnackbar} from 'notistack';
import GenerateSystemReportSnackbarContent from '../PopupPages/GenerateSystemReportSnackbarContent';
import SMCIcon from '../../components/Simple/SMCIcon';

function Home({
    connectedGateways,
    disconnectedGateways,
    disabledGateways,
    plansCount,
    serviceCenterName,
    loggedInUsersCount,
    reload,
    overviewNoticeMessage
}) {
    const { t } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();

    const [isGeneratingReport, setIsGeneratingReport] = useState(false);

    const startReport = useCallback(() => {
        setIsGeneratingReport(true);
        enqueueSnackbar(null, {
            persist: true,
            content: (key) => (
                <GenerateSystemReportSnackbarContent
                    isGlobal={false}
                    id={key}
                    onClose={() => setIsGeneratingReport(false)}
                />
            )
        });
    }, [enqueueSnackbar]);

    return (
        <div>
            <table style={{ textAlign: "left", width: "550px" }}>
                <tbody>
                    <tr className="ViewTabToolbar">
                        <th colSpan="5" align="left" className="ViewTabToolbar ViewLineSeparator">
                            <span className="ViewLineTableTextHeader">{t('SMC_WELCOME_GATEWAYS')}</span>
                        </th>
                        <td className="ViewLineSeparator ViewLineSeparatorLink">
                            <Link className="ViewLink ButtonRealLink"  to="/gateways">{t('SMC_WELCOME_SHOW_ALL')}</Link>
                        </td>
                    </tr>
                    <tr className="ViewTableRow1">
                        <td width="20px" />
                        <td width="20px"><img src={connectedIcon} alt="connected" /></td>
                        <td>{t('SMC_GATEWAY_STATUS_CONNECTED')}</td>
                        <td align="right">{connectedGateways != null ? connectedGateways : <SMCIcon icon="warning" title="Error" alt="error" />}</td>
                        <td width="100px" />
                        <td><Link className="ButtonRealLink" to="/gateways?status=connected">{t('SMC_WELCOME_SHOW')}</Link></td>
                    </tr>
                    <tr className="ViewTableRow1">
                        <td />
                        <td><img src={disconnectedIcon} alt="disconnected" /></td>
                        <td>{t('SMC_GATEWAY_STATUS_NOT_CONNECTED')}</td>
                        <td align="right">{disconnectedGateways != null ? disconnectedGateways : <SMCIcon icon="warning" title="Error" alt="error" />}</td>
                        <td />
                        <td><Link className="ButtonRealLink" to="/gateways?status=disconnected">{t('SMC_WELCOME_SHOW')}</Link></td>
                    </tr>
                    <tr className="ViewTableRow1">
                        <td />
                        <td><img src={disabledIcon} alt="disabled" /></td>
                        <td>{t('SMC_WELCOME_SERVERS_DISABLED')}</td>
                        <td align="right">{disabledGateways != null ? disabledGateways : <SMCIcon icon="warning" title="Error" alt="error" />}</td>
                        <td />
                        <td><Link className="ButtonRealLink" to="/gateways?status=disabled">{t('SMC_WELCOME_SHOW')}</Link></td>
                    </tr>
                    <tr className="ViewTabToolbar">
                        <td colSpan="6">
                            <table width="100%">
                                <tbody>
                                    <tr>
                                        <th align="left" className="ViewTabToolbar ViewLineSeparator">
                                            <span className="ViewLineTableTextHeader">{t('SMC_WELCOME_PLANS')}</span>
                                        </th>
                                        <td width="10" />
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                    <tr className="ViewTableRow1">
                        <td width="20px" />
                        <td width="20px"><img src={plansIcon} alt="plans" /></td>
                        <td>{t('SMC_WELCOME_PLANS')}</td>
                        <td align="right">{plansCount != null ? plansCount : <SMCIcon icon="warning" title="Error" alt="error" />}</td>
                        <td width="100px" />
                        <td><Link className="ButtonRealLink" to="/plans">{t('SMC_WELCOME_SHOW')}</Link></td>
                    </tr>
                    {/* users */}
                    <tr className="ViewTabToolbar">
                        <td colSpan="6">
                            <table width="100%">
                                <tbody>
                                    <tr>
                                        <th align="left" className="ViewTabToolbar ViewLineSeparator">
                                            <span className="ViewLineTableTextHeader">{t('SMC_WELCOME_USERS')}</span>
                                        </th>
                                        <td width="10"></td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                    <tr className="ViewTableRow1">
                        <td />
                        <td><img src={connectedIcon} alt="connected" /></td>
                        <td>{t('SMC_WELCOME_USERS_LOGGEDIN')}</td>
                        <td align="right">{loggedInUsersCount != null ? loggedInUsersCount : <SMCIcon icon="warning" title="Error" alt="error" />}</td>
                        <td colSpan="2" />
                    </tr>
                    {
                        overviewNoticeMessage ? (
                            <tr className="ViewTabToolbar">
                                <td />
                                <td colSpan="5">
                                    <table width="100%">
                                        <tbody><tr>
                                            <th align="left" className="ViewTabToolbar ViewLineSeparator">
                                                <span className="ViewLineTableTextHeader">{ ReactHtmlParser(overviewNoticeMessage) }</span>
                                            </th>
                                            <td width="10"></td>
                                        </tr>
                                    </tbody></table>
                                </td>	
                            </tr>
                        ) : (
                            null
                        )
                    }
                    <tr className="ViewTabToolbar">
                        <td colSpan="6">
                            <table width="100%">
                                <tbody><tr>
                                    <th align="left" className="ViewTabToolbar ViewLineSeparator">
                                        <span className="ViewLineTableTextHeader"></span>
                                    </th>
                                    <td width="10"></td>
                                </tr>
                            </tbody></table>
                        </td>	
                    </tr>
                    <tr className="ViewTableRow1">
                        <td width="10"></td>
                        <td colSpan="2">{t('SMC_WELCOME_SMP_NAME')}</td>
                        <td colSpan="3">{serviceCenterName}</td>
                    </tr>
                </tbody>
            </table>
                <RowLayout style={{ height: 60, position: 'relative', top: 57 }}>
                    <div style={{ width: 180 }} />
                    <SMCButton onClick={reload}>{t('SMC_GEN_REFRESH')}</SMCButton>
                    <SMCButton disabled={isGeneratingReport} onClick={startReport}>{t('SMC_GEN_EXPORT_SUMMARY')}</SMCButton>
                </RowLayout>
        </div>
    );
}

export default Home;